// Copyright (C) 2021 Bystronic Laser AG

export const BaseUrl = process.env.VUE_APP_API_URL;
export const ProductionMode =
  process.env.VUE_APP_DEBUG === 'false' ||
  process.env.VUE_APP_DEBUG === undefined;
